import { Button } from "primereact/button"
import { Calendar } from "primereact/calendar"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { inRange } from "lodash"
import { Dropdown } from "primereact/dropdown"
import { IconField } from "primereact/iconfield"
import { InputIcon } from "primereact/inputicon"
import { InputText } from "primereact/inputtext"
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import { handleLoader } from "redux/counterSlice"
import { getCategories, getReplenishData } from "services/forecastService"
import { formateDate } from "utils/formatDate"

export type ReplenishData = {
    client_env: string
    product_id?: number[]
    category_id?: string[]
    replenishment_range_start_date?: string
    replenishment_range_end_date?: string
    search_product: string
    show_data_in?: string
    page: number
    size_limit: number
}

type Product = {
    id: number
    product_name: string
}

type CategoryProductList = {
    id: number
    category_name: string
    products: Product[]
}

export type ReplenishDataType = {
    accuracy: number
    result: any[]
}



const Replenish = () => {

    const dropdownRef: any = useRef(null)
    const showDisplayList = ["Units"]
    const [replenishData, setReplenishData] = useState<ReplenishDataType>()
    const [searchParams] = useSearchParams()
    const firstForecast: number | null = searchParams.get("first") !== null ? Number(searchParams.get("first")) : 0
    const [dates, setDates] = useState<Date[]>(() => {
        const today = new Date();
        const nextWeek = new Date();
        nextWeek.setDate(today.getDate() + 7);
        return [today, nextWeek];
    })
    const [first, setFirst] = useState<number>(firstForecast)
    const [sortField, setSortField] = useState("") // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>("") // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState<number>(50)
    const [filterReplenish, setFilterReplenish] = useState<ReplenishData>({
        client_env: localStorage.getItem("clientName") as string,
        product_id: [],
        category_id: [],
        replenishment_range_start_date: formateDate(new Date()),
        replenishment_range_end_date: formateDate(new Date(new Date().setDate(new Date().getDate() + 7))),
        show_data_in: "Units",
        page: 1,
        size_limit: rowsPerPage,
        search_product: ""

    })
    const [list, setList] = useState<CategoryProductList[]>([])

    const [selectedProducts, setSelectedProducts] = useState<Product[] | null>(null);
    // const [rowClick, setRowClick] = useState<boolean>(true);

    const [buttonBlue, setButtonBlue] = useState<boolean>(false)
    // const [searched, setSearched] = useState<any>({
    //     'product_name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    // })
    // const [globalFilterValue, setGlobalFilterValue] = useState<string>('');

    const typingTimeoutRef = useRef<any>(null);

    const dispatch = useDispatch()

    const handleDateSelection = (e: any) => {
        const selectedDatesArray = e.value
        if (selectedDatesArray?.length === 2) {
            // Update the selected dates when a valid range is selected
            setDates(selectedDatesArray)
            setFilterReplenish({
                ...filterReplenish,
                replenishment_range_start_date: formateDate(selectedDatesArray[0]),
                replenishment_range_end_date: formateDate(selectedDatesArray[1]),
            })
        } else {
            // Clear the selection when less than two dates are selected
            setDates([])
        }
    }

    const fetchCategories = async () => {
        try {
            dispatch(handleLoader(true))
            const { result, error } = await getCategories()
            if (error) {
                throw error
            }
            setList(result)
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }


    const fetchData = async (filterReplenish: ReplenishData) => {
        try {
            dispatch(handleLoader(true))
            const { result, error } = await getReplenishData(filterReplenish) //have to make service file for this as well
            if (error) {
                throw error
            }
            setReplenishData(result)
            dispatch(handleLoader(false))
        } catch (error: any) {
            dispatch(handleLoader(false))
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleSubmit = async () => {
        try {
            await fetchData(filterReplenish)
            // dispatch(handleLoader(false))
            setButtonBlue(false)
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    useEffect(() => {


        handleBlueButton()

    }, [filterReplenish.category_id, filterReplenish.product_id, filterReplenish.replenishment_range_end_date, filterReplenish.replenishment_range_start_date, filterReplenish.show_data_in])

    useEffect(() => {
        fetchCategories()
        setButtonBlue(false)

        return () => {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, [])

    useEffect(() => {
        fetchData(filterReplenish)
    }, [rowsPerPage, setRowsPerPage])


    function handleBlueButton() {
        setButtonBlue(true)
    }



    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0) //Move to page 1
    }



    const onCategoryChangeHandler = (e: MultiSelectChangeEvent) => {
        const productList =
            list
                .filter((item) => e.value?.includes(item.category_name) && item.products)
                .flatMap((subItem) => subItem.products) ?? []

        setFilterReplenish((prevArray) => {
            return {
                ...prevArray,
                category_id: e.value,
                product_id:
                    e.value.length <= 0
                        ? []
                        : filterReplenish.product_id?.filter((product) => productList.find((item) => item.id === product) && product),
            }
        })
    }

    const capitalizeHeader = (str: string) => {
        return str
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
    }


    //table data
    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // let _filters = { ...searched };

        // _filters['product_name'].value = value;

        // setSearched(_filters);
        // setGlobalFilterValue(value);


        setFilterReplenish(() => {

            const updatedValue = { ...filterReplenish, search_product: value }
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }

            typingTimeoutRef.current = setTimeout(() => {
                fetchData(updatedValue);
            }, 1500);
            return updatedValue
        })
    };




    return (
        <div className="datatable-wrapper">
            <div className='p-4 content-wrapper'>
                <div className="user-management-section replenishment-section">
                    <div className="d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row">
                        <h4 className="mb-0">Replenishment</h4>
                        <div className="d-flex justify-content-between align-items-center table-right-row">
                            <div className="d-flex align-items-center flex-wrap table-right-first">
                                <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                    <IconField iconPosition="right" className='user-input'>
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText placeholder="Search Product" value={filterReplenish.search_product} onChange={onGlobalFilterChange} />
                                    </IconField>
                                </div>
                                <Button label="Create PO" outlined icon="pi pi-plus" className='outline-icon-btn mr-3 mt-1 mb-1'></Button>
                                <div className="d-flex align-items-center mr-3 mt-1 mb-1">
                                    {/* <span className="text-sm">Category: </span> */}
                                    <MultiSelect
                                        value={filterReplenish.category_id}
                                        className="outline-select multi-select"
                                        style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                                        onChange={(e: MultiSelectChangeEvent) => {

                                            onCategoryChangeHandler(e)
                                        }}
                                        filter
                                        name={"categoryId"}
                                        id={"categoryId"}
                                        placeholder="Select category"
                                        options={list}
                                        optionLabel="category_name"
                                        optionValue="category_name"
                                        //display="chip"
                                        maxSelectedLabels={1}
                                    //showClear
                                    />
                                </div>
                                <div className="d-flex align-items-center mr-3 mt-1 mb-1">
                                    {/* <span className="text-sm">Product: </span> */}
                                    <MultiSelect
                                        showSelectAll={true}
                                        value={filterReplenish.product_id}
                                        className="outline-select multi-select"
                                        style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                                        onChange={(e: MultiSelectChangeEvent) => {
                                            setFilterReplenish({ ...filterReplenish, product_id: e.value })

                                        }}
                                        filter
                                        name={"productId"}
                                        id={"productId"}
                                        placeholder="Select product"
                                        options={
                                            list
                                                .filter((item) => filterReplenish.category_id?.includes(item.category_name) && item.products)
                                                .flatMap((subItem) => subItem.products) ?? []
                                        }
                                        optionLabel="product_name"
                                        optionValue="id"
                                        //display="chip"
                                        maxSelectedLabels={1}
                                    //showClear
                                    />
                                </div>
                                <div className="d-flex align-items-center mr-3 mt-1 mb-1">
                                    {/* <span className="text-sm">Show data in: </span> */}
                                    <Dropdown
                                        ref={dropdownRef}
                                        value={filterReplenish.show_data_in}
                                        name="showData"
                                        id="showData"
                                        style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                                        onChange={(e) => {
                                            setFilterReplenish({ ...filterReplenish, show_data_in: e.value })

                                        }}
                                        options={showDisplayList}
                                        placeholder="Select an interval"
                                        optionLabel=""
                                        className="outline-select"
                                    />
                                </div>
                                <div className="d-flex align-items-center mr-3 mt-1 mb-1 voice-filter-col filter-calendar">
                                    <Calendar
                                        minDate={new Date()}
                                        name="duration"
                                        value={dates}
                                        onChange={handleDateSelection}
                                        selectionMode="range"
                                        showIcon
                                        readOnlyInput
                                    />
                                </div>
                                {/* <Button type="button" className={`btn btn-${(buttonBlue) ? "primary" : 'inactiveSub'}`}
                                onClick={() => handleSubmit()}>
                                Submit
                            </Button> */}
                                <Button type="button" className="outline-btn" onClick={() => handleSubmit()} disabled={!buttonBlue} >Submit</Button>
                            </div>
                        </div>
                    </div>


                    <DataTable value={replenishData?.result ?? []}
                        paginator
                        first={first}
                        onPage={(e) => {
                            setFirst(e.first)
                            setRowsPerPage(e.rows)
                            setFilterReplenish((prevState) => ({ ...prevState, size_limit: e.rows }))
                        }}
                        // filters={searched}

                        globalFilterFields={['product_name']}
                        selectionMode='radiobutton'
                        rowsPerPageOptions={[25, 50, 100]}
                        rows={rowsPerPage}
                        scrollable
                        emptyMessage="No Replenish records found"
                        selection={selectedProducts ? selectedProducts : []}
                        onSelectionChange={(e: any) => setSelectedProducts(e.value)}
                        scrollHeight="500px"
                        tableStyle={{ minWidth: '40rem' }}
                    >

                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                        {replenishData?.result && Object.keys(replenishData?.result[0] ?? {}).map((col, index) => {
                            return <Column key={col} field={col} header={capitalizeHeader(col)} />
                        }
                        )}
                    </DataTable>
                    {/* <div className="col-12 flex justify-content-between px-0">
                    <div className="">
                        Replenishment
                    </div>
                </div> */}
                </div>


            </div>
        </div>
    )

}

export default Replenish
